import React from 'react';
import PropTypes from 'prop-types';
import Dictionary from '../../../model/Dictionary';
import Constants from '../../../model/AppConfiguration';
import MinusIcon from '../../../icons/MinusIcon';
import PlusIcon from '../../../icons/PlusIcon';
import { IconButton } from 'material-ui';

const PassengersCounter = ({ adults, infants, flightId, changePassengerNumber, sufix }) => (
  <div>
    <div>
      <IconButton
        onClick={() => changePassengerNumber('adults', flightId, Constants.operator.minus, sufix)}
      >
        <MinusIcon />
      </IconButton>
      {adults}&nbsp;&nbsp;{Dictionary.flights.adults}
      <IconButton
        onClick={() => changePassengerNumber('adults', flightId, Constants.operator.plus, sufix)}
      >
        <PlusIcon />
      </IconButton>
    </div>
    <div>
      <IconButton
        onClick={() => changePassengerNumber('infants', flightId, Constants.operator.minus, sufix)}
      >
        <MinusIcon />
      </IconButton>
      {infants}&nbsp;&nbsp;{Dictionary.flights.infants}
      <IconButton
        onClick={() => changePassengerNumber('infants', flightId, Constants.operator.plus, sufix)}
      >
        <PlusIcon />
      </IconButton>
    </div>
  </div>
);

PassengersCounter.propTypes = {
  adults: PropTypes.number,
  infants: PropTypes.number,
  flightId: PropTypes.string,
  changePassengerNumber: PropTypes.func,
  sufix: PropTypes.string,
};

export default PassengersCounter;



// WEBPACK FOOTER //
// ./src/components/flights/passengerCounters/PassengerCounters.js